import i18n from '../i18n';
import {
  FIELD_OPTIONS,
  PRODUCT_ID_DHCI,
  PRODUCT_ID_DHCI_ALLETRA6K,
  PRODUCT_ID_PRIMERA,
  PRODUCT_ID_ALLETRA,
  PRODUCT_ID_ALLETRA5k,
  PRODUCT_ID_ALLETRA6k,
  PRODUCT_ID_ALLETRA9k,
  PRODUCT_ID_BAAS,
  PRODUCT_ID_OAAS,
  PRODUCT_ID_BAAS_5K_G,
  PRODUCT_ID_BAAS_6K_B,
  PRODUCT_ID_BAAS_9K_M,
  PRIMERA_CONFIGS,
  ALLETRAMP_CONFIGS,
  OAAS_CONFIGS,
  STORAGE_PURCHASE_OPT,
  PRODUCT_ID_FILE,
  PRODUCT_ID_ALLETRAFILE,
  STORAGE_PURCHASE_OPT_FILE,
  PRODUCT_ID_PCBE,
  SIMPLIVITY_MODEL_OPTIONS,
  PCBE_FIELD_OPTIONS,
  ALLETRAMP_CONFIGURATION,
  PCBE_INSTALLATION_OPTION,
  PRODUCT_ID_SDS,
  PRODUCT_ID_ALLETRAB10K,
  SELECT_CABLETRAY,
  GREENLAKE_PLATFORM_OPTIONS,
  PCBE_HYPERVISOR,
} from '../constants';

export const getTechDocFolderName = (productId) => {
  const techDocFolders = {
    [PRODUCT_ID_ALLETRAFILE]: 'alletra_mp_file_files',
    [PRODUCT_ID_ALLETRAB10K]: 'alletra_mp_files',
    [PRODUCT_ID_ALLETRA9k]: 'minotaur_files',
    [PRODUCT_ID_ALLETRA6k]: 'bluetail_files',
    [PRODUCT_ID_ALLETRA5k]: 'alletra5K_files',
    [PRODUCT_ID_DHCI_ALLETRA6K]: 'dHCI6K_files',
    [PRODUCT_ID_BAAS_5K_G]: 'baas_5k_general_files',
    [PRODUCT_ID_BAAS_6K_B]: 'baas_6K_business_files',
    [PRODUCT_ID_BAAS_9K_M]: 'baas_9K_mission_files',
    [PRODUCT_ID_PCBE]: 'pcbe_files',
    [PRODUCT_ID_OAAS]: 'home_fleet_files',
    [PRODUCT_ID_SDS]: 'GLB_SDS_AWS_files',
  };
  let folderName = techDocFolders[productId];
  if (!folderName) {
    folderName = productId;
  }
  return {
    folderName,
    productId,
  };
};

export const getModelListFolders = (productId) => {
  let folderObjArr = [getTechDocFolderName(productId)];
  switch (productId) {
    case PRODUCT_ID_ALLETRA:
      folderObjArr = [
        getTechDocFolderName(PRODUCT_ID_ALLETRA5k),
        getTechDocFolderName(PRODUCT_ID_ALLETRA6k),
        getTechDocFolderName(PRODUCT_ID_ALLETRA9k),
      ];
      break;
    case PRODUCT_ID_BAAS:
      folderObjArr = [
        getTechDocFolderName(PRODUCT_ID_BAAS_5K_G),
        getTechDocFolderName(PRODUCT_ID_BAAS_6K_B),
        getTechDocFolderName(PRODUCT_ID_BAAS_9K_M),
      ];
      break;
    case PRODUCT_ID_ALLETRAB10K:
      folderObjArr = [getTechDocFolderName(PRODUCT_ID_ALLETRAB10K)];
      break;
    case PRODUCT_ID_OAAS:
      folderObjArr = [getTechDocFolderName(PRODUCT_ID_OAAS)];
      break;
    case PRODUCT_ID_FILE:
      folderObjArr = [getTechDocFolderName(PRODUCT_ID_ALLETRAFILE)];
      break;
    case PRODUCT_ID_DHCI:
      folderObjArr = [
        getTechDocFolderName(PRODUCT_ID_DHCI_ALLETRA6K),
        getTechDocFolderName(PRODUCT_ID_DHCI),
      ];
      break;
    case PRODUCT_ID_PCBE:
      folderObjArr = [getTechDocFolderName(PRODUCT_ID_PCBE)];
      break;
    case PRODUCT_ID_SDS:
      folderObjArr = [getTechDocFolderName(PRODUCT_ID_SDS)];
      break;
    default:
      break;
  }
  return folderObjArr;
};

export const getModelLabel = (productId) => {
  let label = '';
  switch (productId) {
    case PRODUCT_ID_BAAS:
    case PRODUCT_ID_OAAS:
    case PRODUCT_ID_BAAS_5K_G:
    case PRODUCT_ID_BAAS_6K_B:
    case PRODUCT_ID_BAAS_9K_M:
    case PRODUCT_ID_FILE:
    case PRODUCT_ID_PCBE:
    case PRODUCT_ID_SDS:
      label = i18n.t('storageTier');
      break;
    default:
      label = i18n.t('model');
  }
  return label;
};

export const getOptInfo = (props) => {
  const { productId, opt } = props;
  let options = [];
  let selectBoxLabel = '';
  let selectedOptLabel = null;
  let selectedOptValue = null;
  let hpeAlletraDHCIOptions = [];
  let selectBoxLabelForHPEAlletraDHCI = '';
  let selectedOptLabelForHPEAlletraDHCI = null;
  let selectedOptValueForHPEAlletraDHCI = null;
  let simplivityOptions = [];
  let simplivitySelectBoxLabel = '';
  let simplivitySelectedOptLabel = null;
  let simplivitySelectedOptValue = null;
  let optionsForConnectConfig = [];
  let selectBoxLabelforConnect = '';
  let selectedOptLabelforConnect = null;
  let selectedOptValueforConnect = null;
  let optionsForStoragePurchase = [];
  let selectBoxLabelForStoragePurchase = '';
  let selectedOptLabelForStoragePurchase = null;
  let selectedOptValueForStoragePurchase = null;
  let optionsForConfiguration = [];
  let selectBoxLabelforConfiguration = '';
  let selectedOptLabelforConfiguration = null;
  let selectedOptValueforConfiguration = null;
  let optionsForCableTray = [];
  let selectBoxLabelforCableTray = '';
  let selectedOptLabelforCableTray = null;
  let selectedOptValueforCableTray = null;
  let optionsForGreenlakePlatform = [];
  let selectBoxLabelforGreenlakePlatform = '';
  let selectedOptLabelforGreenlakePlatform = null;
  let selectedOptValueforGreenlakePlatform = null;
  let optionsForHypervisor = [];
  let selectBoxLabelforHypervisor = '';
  let selectedOptLabelforHypervisor = null;
  let selectedOptValueforHypervisor = null;

  switch (productId) {
    case PRODUCT_ID_DHCI:
    case PRODUCT_ID_DHCI_ALLETRA6K:
      options = FIELD_OPTIONS;
      selectBoxLabel = i18n.t('configVCenter');
      break;
    case PRODUCT_ID_PRIMERA:
      options = PRIMERA_CONFIGS;
      selectBoxLabel = i18n.t('selectArrayModelDescPrimera');
      break;
    case PRODUCT_ID_ALLETRAB10K:
      optionsForCableTray = SELECT_CABLETRAY;
      selectBoxLabelforCableTray = i18n.t('selectCableTray');
      options = PRIMERA_CONFIGS;
      selectBoxLabel = i18n.t('selectArrayModelDescInstallationType');
      optionsForConnectConfig = ALLETRAMP_CONFIGS;
      selectBoxLabelforConnect = i18n.t('selectConnect');
      optionsForGreenlakePlatform = GREENLAKE_PLATFORM_OPTIONS;
      selectBoxLabelforGreenlakePlatform = i18n.t('hpeGreenLakePlatform');
      break;
    case PRODUCT_ID_ALLETRA9k:
      options = PRIMERA_CONFIGS;
      selectBoxLabel = i18n.t('selectArrayModelDescPrimera');
      break;
    case PRODUCT_ID_OAAS:
      optionsForStoragePurchase = STORAGE_PURCHASE_OPT_FILE;
      selectBoxLabelForStoragePurchase = i18n.t('selectStoragePurchase');
      optionsForConnectConfig = OAAS_CONFIGS;
      selectBoxLabelforConnect = i18n.t('selectConnect');
      optionsForConfiguration = ALLETRAMP_CONFIGURATION;
      selectBoxLabelforConfiguration = i18n.t('selectConfiguration');
      break;
    case PRODUCT_ID_PCBE:
      options = PCBE_INSTALLATION_OPTION;
      selectBoxLabel = i18n.t('selectArrayModelDescInstallationType');
      hpeAlletraDHCIOptions = PCBE_FIELD_OPTIONS;
      selectBoxLabelForHPEAlletraDHCI = i18n.t('environment');
      simplivityOptions = SIMPLIVITY_MODEL_OPTIONS;
      simplivitySelectBoxLabel = i18n.t('simpliVityModel');
      optionsForStoragePurchase = STORAGE_PURCHASE_OPT;
      selectBoxLabelForStoragePurchase = i18n.t('selectStoragePurchase');
      optionsForHypervisor = PCBE_HYPERVISOR;
      selectBoxLabelforHypervisor = i18n.t('hypervisor');
      break;
    case PRODUCT_ID_FILE:
      optionsForStoragePurchase = STORAGE_PURCHASE_OPT_FILE;
      selectBoxLabelForStoragePurchase = i18n.t('selectStoragePurchase');
      break;
    default:
      break;
  }
  if (options.length > 0) {
    const selectedItem = options.filter((obj) => obj.val === opt);
    if (selectedItem.length > 0) {
      selectedOptLabel = selectedItem[0].lab;
      selectedOptValue = selectedItem[0].val;
    }
  }
  if (optionsForCableTray.length > 0) {
    const selectedItem = optionsForCableTray.filter((obj) => obj.val === '');
    if (selectedItem.length > 0) {
      selectedOptLabelforCableTray = selectedItem[0].lab;
      selectedOptValueforCableTray = selectedItem[0].val;
    }
  }
  if (hpeAlletraDHCIOptions.length > 0) {
    const selectedItem = hpeAlletraDHCIOptions.filter((obj) => obj.val === '');
    if (selectedItem.length > 0) {
      selectedOptLabelForHPEAlletraDHCI = selectedItem[0].lab;
      selectedOptValueForHPEAlletraDHCI = selectedItem[0].val;
    }
  }
  if (simplivityOptions.length > 0) {
    const selectedItem = simplivityOptions.filter((obj) => obj.val === '');
    if (selectedItem.length > 0) {
      simplivitySelectedOptLabel = selectedItem[0].lab;
      simplivitySelectedOptValue = selectedItem[0].val;
    }
  }
  if (optionsForConnectConfig.length > 0) {
    const selectedItem = optionsForConnectConfig.filter(
      (obj) => obj.val === '',
    );
    if (selectedItem.length > 0) {
      selectedOptLabelforConnect = selectedItem[0].lab;
      selectedOptValueforConnect = selectedItem[0].val;
    }
  }
  if (optionsForGreenlakePlatform.length > 0) {
    const selectedItem = optionsForGreenlakePlatform.filter(
      (obj) => obj.val === '',
    );
    if (selectedItem.length > 0) {
      selectedOptLabelforGreenlakePlatform = selectedItem[0].lab;
      selectedOptValueforGreenlakePlatform = selectedItem[0].val;
    }
  }
  if (optionsForConfiguration.length > 0) {
    const selectedItem = optionsForConfiguration.filter(
      (obj) => obj.val === '',
    );
    if (selectedItem.length > 0) {
      selectedOptLabelforConfiguration = selectedItem[0].lab;
      selectedOptValueforConfiguration = selectedItem[0].val;
    }
  }
  if (optionsForStoragePurchase.length > 0) {
    const selectedItem = optionsForStoragePurchase.filter(
      (obj) => obj.val === '',
    );
    if (selectedItem.length > 0) {
      selectedOptLabelForStoragePurchase = selectedItem[0].lab;
      selectedOptValueForStoragePurchase = selectedItem[0].val;
    }
  }
  if (optionsForHypervisor.length > 0) {
    const selectedItem = optionsForHypervisor.filter((obj) => obj.val === '');
    if (selectedItem.length > 0) {
      selectedOptLabelforHypervisor = selectedItem[0].lab;
      selectedOptValueforHypervisor = selectedItem[0].val;
    }
  }
  return {
    selectBoxLabel,
    options,
    selectedOptLabel,
    selectedOptValue,
    selectBoxLabelForHPEAlletraDHCI,
    hpeAlletraDHCIOptions,
    selectedOptLabelForHPEAlletraDHCI,
    selectedOptValueForHPEAlletraDHCI,
    simplivitySelectBoxLabel,
    simplivityOptions,
    simplivitySelectedOptLabel,
    simplivitySelectedOptValue,
    selectBoxLabelforConnect,
    optionsForConnectConfig,
    selectedOptLabelforConnect,
    selectedOptValueforConnect,
    selectBoxLabelForStoragePurchase,
    optionsForStoragePurchase,
    selectedOptLabelForStoragePurchase,
    selectedOptValueForStoragePurchase,
    selectBoxLabelforConfiguration,
    optionsForConfiguration,
    selectedOptLabelforConfiguration,
    selectedOptValueforConfiguration,
    optionsForCableTray,
    selectBoxLabelforCableTray,
    selectedOptLabelforCableTray,
    selectedOptValueforCableTray,
    optionsForGreenlakePlatform,
    selectBoxLabelforGreenlakePlatform,
    selectedOptLabelforGreenlakePlatform,
    selectedOptValueforGreenlakePlatform,
    optionsForHypervisor,
    selectBoxLabelforHypervisor,
    selectedOptLabelforHypervisor,
    selectedOptValueforHypervisor,
  };
};
